import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "iconLeftCaret",
  "use": "iconLeftCaret-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"iconLeftCaret\">\n<g id=\"iconLeftCaret_general/dropdown\">\n<path id=\"iconLeftCaret_web/icons/general/dropdown-chevron-closed\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.5861 15.9998L17.4142 13.1717L16 11.7574L11.7574 16.0001L13.1716 17.4143L13.1719 17.414L16.0003 20.2425L17.4145 18.8282L14.5861 15.9998Z\" fill=\"#2D2D2D\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol